import {ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs";
import {TranslateService} from "ng2-translate";
import {IdentityModel} from "../../identity/identity.model";
import {QrCodePageComponent} from "../../ui-elements/qr-code/qr-code-page/qr-code-page.component";
import {NavigationService} from "../../orchestration/navigation.service";
import {ResponsiveService} from "../../orchestration/responsive.service";
import {SessionEvents} from "../../orchestration/session-events";
import {EntitlementData} from "../../deal/entitlement-entity.model";

@Component({
    selector: "woa-ticket",
    templateUrl: "./ticket.component.html"
})
export class TicketComponent implements OnInit, OnDestroy {
    @Input() ticket: EntitlementData;
    @Input() index: number;

    rows: number = 1;
    columns: number = 1;
    placeholderContainerSize: number = 0;
    stampIcon: string;
    private _content: ElementRef;
    private _countdown: ElementRef;
    private subscriptions: Subscription = new Subscription();

    @ViewChild("content") private set content(content: ElementRef) {
        if (content) {
            this._content = content;
            this.refresh();
        }
    }

    @ViewChild("countdown") private set countdown(countdown: ElementRef) {
        if (countdown) {
            this._countdown = countdown;
            this.refresh();
        }
    }

    constructor(private identityModel: IdentityModel,
                private changeDetectorRef: ChangeDetectorRef,
                private responsiveService: ResponsiveService,
                private navigationService: NavigationService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.subscriptions.add(SessionEvents.currentApp$.subscribe(() => {
            setTimeout(() => {
                this.refresh();
                this.changeDetectorRef.detectChanges();
                setTimeout(() => {
                    this.refresh();
                    this.changeDetectorRef.detectChanges();
                });
            });
        }));
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => {
            this.refresh();
            this.changeDetectorRef.detectChanges();
        }));

        this.identityModel.ticketUsage[this.ticket.externalId] = Math.max(this.ticket.usageCount, this.identityModel.ticketUsage[this.ticket.externalId] || 0);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private refresh(): void {
        if (!this.ticket || !this._content || !this._content.nativeElement) {
            return;
        }
        const spec: string = getComputedStyle(this._content.nativeElement).getPropertyValue("--themed-ticket-max-column-spec").trim();
        const maxCols: number[] = spec.split(/[, ]/).map((s) => parseInt(s.trim()));
        this.rows = (() => {
            for(let rows: number = 1; rows <= maxCols.length; rows++) {
                if (this.ticket.usageLimit <= (rows * maxCols[rows - 1])) {
                    return rows;
                }
            }
            return 0;
        })();
        this.columns = Math.ceil(this.ticket.usageLimit / this.rows);
        this.stampIcon = getComputedStyle(this._content.nativeElement).getPropertyValue("--themed-ticket-stamp-icon").trim();

        if (this._countdown && this._content.nativeElement) {
            const cellHeight = Math.floor(this._countdown.nativeElement.offsetHeight / this.rows);
            const cellWidth = Math.floor(this._countdown.nativeElement.offsetWidth / this.columns);
            this.placeholderContainerSize = Math.min(cellHeight, cellWidth, 65);
        }
    }

    span(className: string, id: string, content: any): string {
        return "<span class='" + className + "' id='" + id + "'>" + content + "</span>";
    }

    get cells(): Array<number> {
        return Array.from(Array(this.ticket.usageLimit), (_, x) => x);
    }

    getStampRotation(stampNr: number): string {
        return (((this.ticket.appText1.charCodeAt(stampNr % this.ticket.appText1.length) * 13) % 360) - 180) + "deg";
    }

    get cardTheme(): string {
        return this.ticket.theme ? this.ticket.theme : "default";
    }

    get usageCount(): number {
        return this.identityModel.ticketUsage[this.ticket.externalId];
    }

    async showQrCode(event: MouseEvent): Promise<void> {
        event.stopPropagation();
        await QrCodePageComponent.showQrCode(this.navigationService, this.ticket.externalId, this.translate.instant("woa.label.ticket.qrCode"));
        this.identityModel.ticketUsage[this.ticket.externalId]++;
    }
}



// WEBPACK FOOTER //
// ./src/app/loyalty-card/ticket/ticket.component.ts